"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakeAssertFunction = exports.assertFunction = exports.FunctionAssertionError = void 0;
var assert_1 = require("./assert");
var tuple_1 = require("../types/tuple");
var FunctionAssertionError = /** @class */ (function (_super) {
    __extends(FunctionAssertionError, _super);
    function FunctionAssertionError(functionName, argsLength, invalidations) {
        var _this = _super.call(this, invalidations) || this;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // Set the prototype explicitly.
        Object.setPrototypeOf(_this, FunctionAssertionError.prototype);
        var args = __spreadArray([], __read(Array(argsLength).keys()), false).map(function (index) { return "arg" + index; }).join(', ');
        var prefix = functionName.length === 0 ? "function (" + args + ") - args" : "function " + functionName + "(" + args + ") - args";
        _this.message = "" + prefix + _this.message;
        _this.functionName = functionName;
        return _this;
    }
    return FunctionAssertionError;
}(assert_1.AssertionError));
exports.FunctionAssertionError = FunctionAssertionError;
var defaultCoercer = function (guard, path, value) { return value; };
/**
 * Assert a functions arguments using type-guards
 * @param argumentsGuards guards for arguments
 * @param func the function that arguments are passed to
 * @param name override function name
 */
var assertFunction = function (argumentsGuards, func, options) {
    var _a, e_1, _b;
    var _c;
    var funcArgsGuard = (0, tuple_1.tuple)(argumentsGuards);
    var functionName = (_c = options === null || options === void 0 ? void 0 : options.name) !== null && _c !== void 0 ? _c : func.name;
    var invalidationHandler = options === null || options === void 0 ? void 0 : options.error;
    if (invalidationHandler === undefined) {
        invalidationHandler = function (invalidation) {
            return new FunctionAssertionError(functionName, argumentsGuards.length, invalidation);
        };
    }
    var assertedFunc = (_a = {},
        _a[functionName] = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var coercedArguments = funcArgsGuard.coerce([], args, (_a = options === null || options === void 0 ? void 0 : options.coercer) !== null && _a !== void 0 ? _a : defaultCoercer);
            (0, assert_1.assert)(funcArgsGuard, coercedArguments, invalidationHandler);
            return func.apply(void 0, __spreadArray([], __read(coercedArguments), false));
        },
        _a)[functionName];
    if ((options === null || options === void 0 ? void 0 : options.props) !== undefined) {
        try {
            for (var _d = __values(Object.keys(options.props)), _e = _d.next(); !_e.done; _e = _d.next()) {
                var key = _e.value;
                var funcAny = assertedFunc;
                funcAny[key] = options.props[key];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return assertedFunc;
};
exports.assertFunction = assertFunction;
/**
 * Fake assert a functions arguments using type-guards to get correct types
 * @param argumentsGuards guards for arguments
 * @param func the function that arguments are passed to
 * @param name override function name
 */
var fakeAssertFunction = function (argumentsGuards, func, options) {
    var _a, e_2, _b;
    var _c;
    var functionName = (_c = options === null || options === void 0 ? void 0 : options.name) !== null && _c !== void 0 ? _c : func.name;
    var assertedFunc = (_a = {},
        _a[functionName] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return func.apply(void 0, __spreadArray([], __read(args), false));
        },
        _a)[functionName];
    if ((options === null || options === void 0 ? void 0 : options.props) !== undefined) {
        try {
            for (var _d = __values(Object.keys(options.props)), _e = _d.next(); !_e.done; _e = _d.next()) {
                var key = _e.value;
                var funcAny = assertedFunc;
                funcAny[key] = options.props[key];
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    return assertedFunc;
};
exports.fakeAssertFunction = fakeAssertFunction;
